// extracted by mini-css-extract-plugin
export var body = "_cg-0";
export var sectionHeader = "_cg-4";
export var shortcutColumns = "_cg-2";
export var shortcutList = "_cg-1";
export var shortcutSection = "_cg-3";